exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suspend-user-modal {\n  text-align: center;\n  margin-top: 125px; }\n\n.suspend-user-close-button {\n  border: none;\n  background: #f2f2f2;\n  color: #9b9b9b; }\n\n.suspend-user-modal .modal-header {\n  padding-left: 30%;\n  border-bottom: none; }\n\n.suspend-user-modal .modal-title {\n  padding-top: 20px;\n  font-size: 25px; }\n\n.suspend-user-modal .modal-footer {\n  border-top: none; }\n\n.suspend-user-save-button {\n  width: 130px;\n  background-color: #4ec8ed;\n  border: none; }\n\n.suspend-user-modal .modal-content {\n  background: #f2f2f2;\n  border: none; }\n", ""]);

// exports
